import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { Users, Briefcase, ClipboardText, CurrencyGbp, Buildings, CheckCircle, DownloadSimple } from "@phosphor-icons/react";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid } from "recharts";
import { Button } from "@/components/ui/button";
import AnomalyWidget from "@/components/AnomalyWidget";

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setS(r.data)); }, []);
  const chartData = [
    { name: "Staff", value: s?.total_staff || 0 },
    { name: "Companies", value: s?.total_companies || 0 },
    { name: "Jobs", value: s?.active_jobs || 0 },
    { name: "Bookings", value: s?.total_bookings || 0 },
    { name: "Completed", value: s?.completed_bookings || 0 },
  ];
  return (
    <div className="space-y-6">
      <div>
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <div>
            <div className="label-caps">Platform admin</div>
            <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900">Overview</h1>
          </div>
          <Button data-testid="timesheet-download-btn"
            onClick={() => { fetch(`${API}/admin/timesheets.csv`, { credentials: "include" }).then(r => r.blob()).then(b => { const url = URL.createObjectURL(b); const a = document.createElement("a"); a.href = url; a.download = `shiftflex-timesheets.csv`; a.click(); URL.revokeObjectURL(url); }); }}
            className="bg-slate-900 hover:bg-slate-800"><DownloadSimple size={16} className="mr-1.5"/> Timesheet CSV</Button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <div className="md:col-span-2 grid grid-cols-2 md:grid-cols-3 gap-3">
          <Card icon={Users} label="Total staff" value={s?.total_staff ?? 0} />
          <Card icon={CheckCircle} label="Active staff" value={s?.active_staff ?? 0} />
          <Card icon={Users} label="Pending staff" value={s?.pending_staff ?? 0} accent="yellow" />
          <Card icon={Buildings} label="Companies" value={s?.total_companies ?? 0} />
          <Card icon={Buildings} label="Pending companies" value={s?.pending_companies ?? 0} accent="yellow" />
          <Card icon={Briefcase} label="Active jobs" value={s?.active_jobs ?? 0} />
          <Card icon={ClipboardText} label="Total bookings" value={s?.total_bookings ?? 0} />
          <Card icon={CurrencyGbp} label="Revenue" value={`£${s?.revenue ?? 0}`} />
        </div>
        <AnomalyWidget />
      </div>
      <div className="card-tactile p-6">
        <div className="label-caps mb-2">Platform metrics</div>
        <div className="h-72">
          <ResponsiveContainer>
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
              <XAxis dataKey="name" stroke="#475569" fontSize={12} />
              <YAxis stroke="#475569" fontSize={12} />
              <Tooltip />
              <Bar dataKey="value" fill="#2563EB" radius={[4,4,0,0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}

function Card({ icon: I, label, value, accent }) {
  const color = accent === "yellow" ? "text-yellow-600" : "text-blue-600";
  return (
    <div className="card-tactile p-4">
      <I size={20} className={`${color} mb-2`} />
      <div className="label-caps">{label}</div>
      <div className="font-display text-2xl font-extrabold text-slate-900">{value}</div>
    </div>
  );
}
